import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import Sortable from 'react-sortablejs';
import { onChange } from '../../../controller/theme_checkout';
import style from './style.css';
import { locale } from '../../../utils/i18n';
import constants, { THEME_CONSTANTS } from '../../../utils/constants';

class DragAndDrop extends Component {
  constructor(props) {
    super(props);
  }

  render({ merchantPayModes, onPaymodeReOrder }, {}) {
    return (
      <section>
        <div style={{ marginTop: 50 }}>
          <h6 className={`select-color uppercase`}>{locale('theme.sort.paymode.title')}</h6>
          <Sortable
            options={{ animation: 150 }}
            className="block-list"
            tag="div"
            onEnd={event => onPaymodeReOrder(event.oldIndex, event.newIndex)}
          >
            {merchantPayModes &&
              merchantPayModes.map(paymodeObj => {
                let paymodeName = paymodeObj.name;
                if (paymodeObj.type == 'CARD') {
                  paymodeName = constants.CARD_NAME;
                }
                if(paymodeObj.type == 'UPI'){
                  paymodeName = constants.UPI;
                }
                return (
                  <div data-id={paymodeObj.id} className={`${style['drag-card']}`}>
                    <span className={`${style.dash} pos-r`} />
                    <span className={`${style['drag-txt']}`}>{paymodeName}</span>
                  </div>
                );
              })}
          </Sortable>
        </div>
      </section>
    );
  }
}

export default connect(
  'merchantPayModes',
  onChange
)(DragAndDrop);



// WEBPACK FOOTER //
// ./checkout/components/draganddrop/index.js